import salesBanner from './assets/banner-sales.png';
import intoreBanner from './assets/banner-in-store.png';
import qrStaticBanner from './assets/banner-static-qr.png';

export const LATEST_FEATURES_DATA = [
  {
    banner: qrStaticBanner,
    alt: 'QR Estatico',
    title: 'Los cobros con Kueski Pay ahora son más rápidos',
    list: {
      type: 'number',
      title:
        'Conoce <strong>QR estático</strong>, una nueva opción para cobrar en 3 pasos:',
      data: [
        'Pídele al cliente que escanee el QR impreso.',
        'Indícale el monto de la compra.',
        'Confirma el cobro en la sección de <strong>Ventas.</strong>',
      ],
    },
    content:
      '<p>¡Listo! Ya puedes entregar los productos.</p><p>¿No lo tienes? Pronto enviaremos el material impreso a tu tienda.</p>',
    link: {
      url: '/faq',
      text: 'Conocer más',
    },
  },
  {
    banner: salesBanner,
    alt: 'Ventas',
    title: 'Creamos la herramienta de Ventas:',
    list: {
      type: '',
      data: [
        'Cambiamos el historial de cobros a <strong>Ventas.</strong>',
        'Aquí podrás consultar y administrar las transacciones de tienda física en tiempo real.',
      ],
    },
  },
  {
    banner: intoreBanner,
    alt: 'Tienda fisica',
    title: 'Creamos la herramienta de Ventas:',
    list: {
      type: '',
      data: [
        'Agrupamos los canales de cobro en la sección de <strong>Tienda física.</strong>',
      ],
    },
  },
];
